import { createSlice } from "@reduxjs/toolkit";
import apiManagerEvent from "api/manager-event";
import moment from "moment";
import { roundTimeEndDay, roundTimeEndSecond, roundTimeEndSecondEvent, roundTimeStartDay, roundTimeStartSecond } from "pages/manager-meeting/functions";
import store from "store/store";
import { createInitialPeriodState, toTimestamp } from 'store/periodState';

export const fetchData = async (data) => {
    try {
        const res = await apiManagerEvent.search(data);
        if (res.status === 200) {
            store.dispatch(setTableData({
                data: res.data,
                total: res.total
            }))
        } else console.log("info: ", res);
    } catch (err) {
        console.log("err: ", err)
    } finally {
        store.dispatch(setIsLoading(false))
    }
}

export const createInitialManagerEventState = () => ({
    tableData: {
        data: [],
        total: 0
    },
    searchQuery: {
        status: ['isactive', 'locked'],
        eventCode: '',
        eventName: '',
        displayModule: ['Landing Page', 'Admin', 'Meeting'],
    },
    isRefresh: false,
    isLoading: false,


    ...createInitialPeriodState({ endSecond: roundTimeEndSecondEvent }),
});

export const managerEventSlice = createSlice({
    name: 'managerEvent',
    initialState: createInitialManagerEventState(),
    reducers: {
        setTableData: (state, action) => void (state.tableData = action.payload),
        setSearchQuery: (state, action) => void(state.searchQuery = action.payload),
        toggleIsRefresh: (state) => void (state.isRefresh = !state.isRefresh),
        setIsLoading: (state, action) => void(state.isLoading = action.payload),

        setTimeProfileTypeId: (state, action) => {
            state.time_profile_type_id = action.payload;
        },
        setStartTimePeriod: {
            reducer: (state, action) => { state.start_time = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setEndTimePeriod: {
            reducer: (state, action) => { state.end_time = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setInterval: (state, action) => {
            state.interval = action.payload;
        },
        setDay: (state, action) => {
            state.day = action.payload;
        },
        setWeek: (state, action) => {
            state.week = action.payload;
        },
        setValue: {
            reducer: (state, action) => {
                state.time_profile_type_id = action.payload.time_profile_type_id;
                state.start_time = action.payload.start_time;
                state.end_time = action.payload.end_time;
                state.interval = action.payload.interval;
                state.day = action.payload.day;
                state.week = action.payload.week;
            },
            prepare: (value) => ({ payload: {
                ...value,
                start_time: toTimestamp(value.start_time),
                end_time: toTimestamp(value.end_time),
            } }),
        },
        setClearValue: (state, action) => {
            state.time_profile_type_id = null;
            state.start_time = null;
            state.end_time = null;
            state.interval = null;
            state.day = null;
            state.week = null;
        },
        setIsChangePeriod: (state, action) => {
            state.isChangePeriod = action.payload;
        },
        setTimeRoom: {
            reducer: (state, action) => {
                state.start = action.payload.start;
                state.end = action.payload.end;
            },
            prepare: (value) => ({ payload: {
                start: toTimestamp(value.start),
                end: toTimestamp(value.end),
            } }),
        },
        setStartTime: {
            reducer: (state, action) => { state.start = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setEndTime: {
            reducer: (state, action) => { state.end = action.payload; },
            prepare: (value) => ({ payload: toTimestamp(value) }),
        },
        setStartTimeSecond: (state, action) => {
            state.startSecond = action.payload;
        },
        setEndTimeSecond: (state, action) => {
            state.endSecond = action.payload;
        },
       
        setStateModalDetail: (state, action) => {
            state.isOpenModalDetail = action.payload.isOpenModalDetail
            state.roomId = action.payload.roomId
        },
        setStateModalCancel: (state, action) => {
            state.isOpenModalCancel = action.payload
        },
        setCurrentTime: (state, action) => {
            state.start = moment(roundTimeStartDay()).add(roundTimeStartSecond(), 'seconds').valueOf();
            state.startSecond = roundTimeStartSecond();
            state.end = moment(roundTimeEndDay()).add(roundTimeEndSecond(), 'seconds').valueOf();
            state.endSecond = roundTimeEndSecond()
        },

        setDefaultTime: (state, action) => {
            state.start = moment(roundTimeStartDay()).add(roundTimeStartSecond(), 'seconds').valueOf();
            state.startSecond = roundTimeStartSecond();
            state.end = moment(roundTimeEndDay()).add(roundTimeEndSecond(), 'seconds').valueOf();
            state.endSecond = roundTimeEndSecondEvent()
        },
    },
    extraReducers: (builder) => {
        builder.addCase('session/sessionEnded', () => createInitialManagerEventState());
    },
})

export const { 
    setTableData, 
    setSearchQuery, 
    toggleIsRefresh, 
    setIsLoading,
    setDefaultTime,
    setTimeProfileTypeId,
    setStartTimePeriod,
    setEndTimePeriod,
    setInterval,
    setDay,
    setWeek,
    setValue,
    setClearValue,
    setIsChangePeriod,
    setTimeRoom,
    setStartTime,
    setEndTime,
    setStartTimeSecond,
    setEndTimeSecond,
    setStateModalDetail,
    setStateModalCancel,
    setCurrentTime

} = managerEventSlice.actions
export default managerEventSlice.reducer
